import { getSanitizedMatomoCategory } from 'services/matomo.service';

export const MATOMO_ACTIONS = {
  TAB_SWITCH: 'Tab Switch',
  TABLE_TOGGLE: 'Table Toggle',
  CHART_TOGGLE: 'Chart Toggle',
} as const;

export function getTrackingPage(pathname: string): string {
  const sanitizedCategory = getSanitizedMatomoCategory(pathname);
  return sanitizedCategory === 'Unmapped' ? pathname : sanitizedCategory;
}
